import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useContext, useEffect, useState } from "react";
import { AppContext, mainAPikey } from "../ContextApi";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ADD_EMPLOYEE_API, DELETE_EMPLOYEE_API } from "../Constants";
import { Placeholder } from "react-bootstrap";

function CashlessDeleteModal(props) {
  const { data } = props;
  const { constantsApiData } = useContext(AppContext);
  const [isLoading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      date_of_leaving: data?.date_of_leaving || "",
      remark: data?.remark || "",
    },
  });

  // Reset form on data changes
  useEffect(() => {
    reset({
      date_of_leaving: data?.date_of_leaving || "",
      remark: data?.remark || "",
    });
  }, [data, reset]);

  const authorizationToken = localStorage.getItem("authorizationToken");

  const onSubmit = async (dataRepo) => {
    setLoading(true);
    const formData = new FormData();
    Object.keys(dataRepo).forEach((key) => {
      formData.append(key, dataRepo[key]);
    });

    formData.append("member_covered_id", data?.member_covered_id);
    const apiUrl = `${process.env.REACT_APP_API_URL}/${mainAPikey}${DELETE_EMPLOYEE_API}`;

    const requestOptionsNew = {
      method: "POST",
      headers: {
        Authorization: authorizationToken,
      },
      body: formData,
    };

    try {
      const response = await fetch(apiUrl, requestOptionsNew);

      const result = await response.json();

      if (result?.success) {
        toast.success(result.message || "Form submitted successfully!");
        props.apiCall();
        props.handleClose();
        reset();
      } else {
        toast.error(result.message || "Something went wrong!");
      }
    } catch (error) {
      toast.error("Failed to submit the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal {...props} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Delete Member</Modal.Title>
        <Button onClick={props.handleClose}>x</Button>
      </Modal.Header>
      <Modal.Body>
        <div className="add-form-members-main-cover-wrapper">
          <form
            id="form-step-1"
            className="form-step active"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row claim-intimate-forms-cover d-flex justify-content-center">
              {[
                {
                  label: "Date of Leaving",
                  name: "date_of_leaving",
                  type: "date",
                  required: "Date of leaving is required",
                },
                {
                  label: "Remark",
                  name: "deletion_remarks",
                  Placeholder: "Enter Remark",
                  type: "text",
                  required: "Remark is required",
                },
              ].map((field) => (
                <div className="col-lg-6 mb-3" key={field.name}>
                  <div className="form-group">
                    <label>
                      {field.label} <span className="error"> * </span>
                    </label>
                    <input
                      type={field.type}
                      className="form-control"
                      {...register(field.name, {
                        required: field.required,
                      })}
                      value={watch(field.name) || ""}
                      onChange={(e) => setValue(field.name, e.target.value)}
                    />
                    {errors[field.name] && (
                      <small className="text-danger">
                        {errors[field.name].message}
                      </small>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="submit-btn-box">
              <input
                type="submit"
                className="register-form-btn mt-4 mb-3"
                value={isLoading ? "Please wait..." : "Submit"}
                disabled={isLoading}
              />
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CashlessDeleteModal;
